// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // ⚠️ vérifie que tu utilises React 18
import App from './App';
import './index.css';
import './i18n'; // 👈 important pour initialiser i18n AVANT App

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
